export const authenticationConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_MODEL: 'USERS_LOGIN_MODEL',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  USER_UPDATE: 'USER_UPDATE',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
  LOGOUT: 'USERS_LOGOUT',
}
